import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../init/getData';
import { DynamicModalContext } from '../../init/dynamicModals';

import { Modal, Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';
import { Button, Spin } from 'antd';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";
import { FaPlus } from "react-icons/fa";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../components/loader/loader';
import AccountForm from '../../accountTab/auxAccount/accountForm';
import { inputValueFormatter, numberFormatter, onChangeValueFormatter } from '../../components/formatters/numberFormatter';



const Transaction = (props) => {

    const { api, userData, settingData, auxAccountData, rateToMainCurrency, rateMainToSecondaryCurrency, currencyData } = useContext(DataContext);
    const { openAddAccountModal } = useContext(DynamicModalContext);
    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);


    const { transactions, setTransactions, transactionsItem, title, debit, credit } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(false);


    const today = new Date().toISOString().split('T')[0];

    const mainCurrency = currencyData.find(item => item.id === settingData.mainCurrencyId);
    const secondaryCurrency = currencyData.find(item => item.id === settingData.secondaryCurrencyId);

    // Account Options
    const accountOptions = auxAccountData?.map(item => ({
        value: item.id,
        label: (item?.parent?.accountId ? item?.parent?.accountId + '.' : '') + item.accountId + ' ' + item.english,
        invoices: item.journalVouchers,
    }));
    const loadAccountOptions = (inputValue, callback) => {
        const filteredOptions = inputValue ? accountOptions.filter(option =>
            option.label.toLowerCase().includes(inputValue.toLowerCase())) : [];
        callback(filteredOptions);
    };


    // Currency Options
    const currencyOptions = currencyData?.map(item => ({
        value: item.id,
        label: item.code,
        rate: item.rate,
        isMultiply: item.isMultiply,
    }))


    // Add new row
    const handleAddRow = () => {
        if (transactions.length > 0) {
            const firstTransactionDetails = transactions[0].details;
            const newTransaction = { ...transactionsItem, details: firstTransactionDetails };
            setTransactions([...transactions, newTransaction]);
        } else {
            setTransactions([...transactions, transactionsItem]);
        }
    };

    // Delete VarientRow
    const handleDeleteRow = (event) => {
        event.preventDefault()
        const updatedRows = transactions.slice(0, -1);
        setTransactions(updatedRows);

    };

    // handle row changes
    const handleRowChange = (index, value, field) => {
        const updatedtransactions = [...transactions];

        if (field == 'account') {
            updatedtransactions[index].accountId = value.value;

        } else if (field == 'currencyId') {
            updatedtransactions[index].currencyId = value.value;
            updatedtransactions[index].rate = value.rate;

        } else if (field == 'debit') {
            updatedtransactions[index].debit = value;
            updatedtransactions[index].totalDebit = value * updatedtransactions[index].rate;

        } else if (field == 'credit') {
            updatedtransactions[index].credit = value;
            updatedtransactions[index].totalCredit = value * updatedtransactions[index].rate;

        } else if (field == 'totalDebit') {
            updatedtransactions[index].totalDebit = value;
            updatedtransactions[index].debit = value / updatedtransactions[index].rate;

        } else if (field == 'totalCredit') {
            updatedtransactions[index].totalCredit = value;
            updatedtransactions[index].credit = value / updatedtransactions[index].rate;
        }
        else if (field == 'details') {
            updatedtransactions[index].details = value;
        }

        const selectedCurrency = currencyData.find(item => item.id === updatedtransactions[index].currencyId);
        updatedtransactions[index].totalDebit = rateToMainCurrency(selectedCurrency, updatedtransactions[index].debit);
        updatedtransactions[index].totalCredit = rateToMainCurrency(selectedCurrency, updatedtransactions[index].credit);


        updatedtransactions[index].secondaryTotalDebit = rateMainToSecondaryCurrency(updatedtransactions[index].totalDebit);
        updatedtransactions[index].secondaryTotalCredit = rateMainToSecondaryCurrency(updatedtransactions[index].totalCredit);

        setTransactions(updatedtransactions);
    }


    const handleDeleteRowIndex = (index) => {
        const updatedRows = transactions.filter((_, i) => i !== index);
        setTransactions(updatedRows);

    };


    const handleDoubleClick = (e, index, feild) => {


        const valueCredit = transactions[index]?.credit || 0;
        const valueDebit = transactions[index]?.debit || 0;

        const totalCredit = debit - (credit - valueCredit);
        const totalDebit = credit - (debit - valueDebit);

        if (feild == 'credit') {
            handleRowChange(index, totalCredit, 'credit');
        }
        else if (feild == 'debit') {
            handleRowChange(index, totalDebit, 'debit');

        }
    };



    return (
        <>

            <Row className="mb-3 g-0" style={{ backgroundColor: 'white' }}>
                <Form.Group as={Col} md={2}>
                    <Form.Label>Account</Form.Label>
                    <FaPlus onClick={() => openAddAccountModal()} style={{ marginLeft: '20px', cursor: 'pointer' }} />
                </Form.Group>


                <Form.Group as={Col} md={1}>
                    <Form.Label>Currency</Form.Label>
                </Form.Group>

                <Form.Group as={Col} md={2}>
                    <Form.Label>Details</Form.Label>
                </Form.Group>

                <Form.Group as={Col} >
                    <Form.Label>Debit</Form.Label>
                </Form.Group>

                <Form.Group as={Col} >
                    <Form.Label>Credit</Form.Label>
                </Form.Group>

                <Form.Group as={Col} md={1}>
                    <Form.Label>Rate</Form.Label>
                </Form.Group>


                <Form.Group as={Col} >
                    <Form.Label>Debit {mainCurrency.code}</Form.Label>
                </Form.Group>


                <Form.Group as={Col} >
                    <Form.Label>Credit {mainCurrency.code}</Form.Label>
                </Form.Group>

                {secondaryCurrency &&
                    <Form.Group as={Col} >
                        <Form.Label>Debit {secondaryCurrency?.code}</Form.Label>
                    </Form.Group>
                }

                {secondaryCurrency &&
                    <Form.Group as={Col} >
                        <Form.Label>Credit {secondaryCurrency?.code}</Form.Label>
                    </Form.Group>
                }

            </Row>




            {transactions.map((row, index) => (
                <div key={index} >
                    {/* Account */}
                    <Row className="mb-0 g-0">
                        <Col md={2}>

                            <AsyncSelect
                                cacheOptions
                                loadOptions={loadAccountOptions}
                                defaultOptions={[]}
                                onChange={(e) => handleRowChange(index, e, 'account')}
                                value={accountOptions.find(option => option.value === transactions[index].accountId) || []}
                                noOptionsMessage={() => 'type to view'}
                                required
                            />
                        </Col>


                        {/* Currency */}
                        <Col md={1}>
                            <Select
                                options={currencyOptions}
                                isSearchable={true}
                                placeholder="Select"
                                onChange={(e) => handleRowChange(index, e, 'currencyId')}
                                value={currencyOptions?.find(option => option.value === transactions[index].currencyId) || []}
                                required
                                disabled={transactions[index].accountId ? false : true}
                            />
                        </Col>



                        {/* Details */}
                        <Col md={2}>
                            <Form.Control as="textarea" rows={1}
                                value={transactions[index].details}
                                onChange={(e) => handleRowChange(index, e.target.value, 'details')}
                                disabled={transactions[index].accountId ? false : true}
                            />
                        </Col>


                        {/* debit */}
                        <Col as={Col} >
                            <Form.Control type="text" min={0} step='any' value={inputValueFormatter(transactions[index].debit)}
                                style={{ backgroundColor: '#FBF2E1' }}
                                onChange={(e) => handleRowChange(index, onChangeValueFormatter(e.target.value), 'debit')}
                                onDoubleClick={(e) => handleDoubleClick(e, index, 'debit')}
                                required
                                disabled={transactions[index].accountId ? false : true}
                            />
                        </Col>

                        {/* credit */}
                        <Col as={Col} >
                            <Form.Control type="text" min={0} step='any' value={inputValueFormatter(transactions[index].credit)}
                                style={{ backgroundColor: '#FBF2E1' }}
                                onChange={(e) => handleRowChange(index, onChangeValueFormatter(e.target.value), 'credit')}
                                onDoubleClick={(e) => handleDoubleClick(e, index, 'credit')}
                                required
                                disabled={transactions[index].accountId ? false : true}
                            />
                        </Col>


                        {/* rate */}
                        <Col md={1}>
                            <Form.Control type="text" min={0} step='any' value={inputValueFormatter(transactions[index].rate)}
                                onChange={(e) => handleRowChange(index, e.target.value, 'rate')}
                                required
                                disabled={true}
                            />
                        </Col>


                        {/* total debit */}
                        <Col>
                            <Form.Control type="text" min={0} step='any' value={inputValueFormatter(transactions[index].totalDebit)}
                                style={{ backgroundColor: '#D5E4D6' }}
                                onChange={(e) => handleRowChange(index, e.target.value, 'totalDebit')}
                                required
                                disabled={true}
                            />
                        </Col>


                        {/* total credit */}
                        <Col>
                            <Form.Control type="text" name="total" id="total" value={numberFormatter(transactions[index].totalCredit)}
                                style={{ backgroundColor: '#D5E4D6' }}
                                onChange={(e) => handleRowChange(index, e.target.value, 'totalCredit')}
                                required
                                disabled={true}
                            />
                        </Col>



                        {/* sec total debit */}
                        {secondaryCurrency &&
                            <Col>
                                <Form.Control type="text" min={0} step='any' value={numberFormatter(transactions[index].secondaryTotalDebit)}
                                    style={{ backgroundColor: '#f1f9ff' }}
                                    required
                                    disabled={true}
                                />
                            </Col>
                        }

                        {/* Sec total credit */}
                        {secondaryCurrency &&
                            <Col>
                                <Form.Control type="text" name="total" id="total" value={numberFormatter(transactions[index].secondaryTotalCredit)}
                                    style={{ backgroundColor: '#f1f9ff' }}
                                    required
                                    disabled={true}
                                />


                            </Col>
                        }

                        <Col className="d-flex justify-content-end" style={{ flex: 0.2 }}>
                            <BiSolidTrash size={18} onClick={e => handleDeleteRowIndex(index)}
                                style={{ cursor: 'pointer', color: '#e6434f', marginTop: '10px' }} />
                        </Col>

                    </Row>


                </div>
            ))
            }



            <Row className="mb-3">

                <Form.Group
                    as={Col}
                    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '30px' }}
                >
                    <FcPlus size={26} style={{ cursor: 'pointer' }} onClick={handleAddRow} />
                    <HiMinusCircle size={28} style={{ cursor: 'pointer' }} onClick={(e) => handleDeleteRow(e)} />

                </Form.Group>

            </Row>
        </>
    )
}


export default Transaction;